import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Column, Control, Label } from "rbx";
import FilterButtons from "../../../components/FilterButtons";

import { DateInput, ItemCategorySelect } from "../../../components/inputs";

const INITIAL_FILTER_STATE = {};

const VehiclePartsFilter = ({ filters, onFilter, onClose }) => {
  const [inputs, setInputs] = useState({ ...filters });
  const handleChange = e => {
    const updates = { ...inputs };
    updates[e.target.name] = parseInt(e.target.value);
    setInputs(prev => ({ ...prev, ...updates }));
  };

  const handleDateChange = e => {
    const updates = { ...inputs };
    updates[e.target.name] = new Date(e.target.value).getTime();
    setInputs({ ...updates });
  };
  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose();
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <div className="inspection-modal-container">
      <Column.Group>
        <Column>
          <ItemCategorySelect
            icon="globe"
            label="Item Category"
            name="ItemCategoryRecIdRef"
            value={inputs.ItemCategoryRecIdRef}
            onChange={handleChange}
          />
        </Column>
      </Column.Group>
      <Column.Group>
        <Column>
          <Control>
            <Label>Start Date</Label>
            <DateInput
              name="CompletedDate_gte"
              value={
                inputs.CompletedDate_gte
                  ? moment(inputs.CompletedDate_gte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>End Date</Label>
            <DateInput
              name="CompletedDate_lte"
              value={
                inputs.CompletedDate_lte
                  ? moment(inputs.CompletedDate_lte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
};

VehiclePartsFilter.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default VehiclePartsFilter;
